import { db } from "@/firebaseConfig";

const userCartCollection = db.collection("user_cart");

const saveUserCart = async (id, data) => {
  userCartCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("UserCart successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateUserCart = async (id, data) => {
  userCartCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("UserCart successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteUserCart = async id => {
  userCartCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("UserCart successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getUserCartById = async id => {
  return userCartCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const deleteAllUserCartByTable = async (tableQR, isAdmin) => {
  if (isAdmin) {
    return;
  }

  userCartCollection
    .where("tableQR", "==", tableQR)
    .get()
    .then(querySnapshot => {
      // Once we get the results, begin a batch
      let batch = db.batch();

      querySnapshot.forEach(doc => {
        // For each doc, add a delete operation to the batch
        batch.delete(doc.ref);
      });

      // Commit the batch
      return batch.commit();
    });
};

export {
  userCartCollection,
  saveUserCart,
  updateUserCart,
  deleteUserCart,
  getUserCartById,
  deleteAllUserCartByTable
};
